/* eslint-disable new-cap */
import React from 'react';
import { useHookstate, type State } from '@hookstate/core';
import { Card, CardHeader, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ManagementInvolvedFilters from '../ManagementQualifiersFilters';
import ChartsInvolved from './components/ChartsInvolved';
import useManagementQualifiersInvolvedState from '~/features/Management/stores/ManagementQualifiersInvolvedState';
import { useLang } from '~/hooks/useLang';
import type { InvolvedFilter, FilterState, IListDispatchTab } from '~/features/Management/interfaces';

interface IInvolvedChartProps {
  readonly expandFilterSearch: State<boolean>;
  readonly valueTab?: IListDispatchTab;
  readonly filters: State<FilterState>;
  readonly setFilters: (filters: InvolvedFilter) => void;
  readonly searched: boolean;
  readonly setSearched: (value: boolean) => void;
}

export default function InvolvedChart({
  expandFilterSearch,
  valueTab,
  filters,
  setFilters,
  searched,
  setSearched,
}: IInvolvedChartProps) {
  const { loadingCharts } = useManagementQualifiersInvolvedState();
  const labelBotton = useHookstate<string>('Search');
  const { translate } = useLang();
  
  return (
    <Card
      sx={{
        boxShadow: 4,
        paddingBottom: 2,
        height: expandFilterSearch.value ? 'auto' : 50,
      }}
    >
      <CardHeader
        title={`${translate('Filters')}`}
        avatar={
          <IconButton
            onClick={() => {
              expandFilterSearch.set(!expandFilterSearch.get());
            }}
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginRight: 1,
              padding: 0,
            }}
          >
            {expandFilterSearch.value ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        titleTypographyProps={{ fontWeight: 'bold', fontSize: 18 }}
      />
      <ManagementInvolvedFilters
        hidden={expandFilterSearch.get()}
        labelButton={labelBotton}
        arrestedFilter
        peopleCircunstanceFilter
        involvedTypeFilter
        destinationFinalFilter
        periodFilter
        valueTab={valueTab}
        clearFilters={() => {
          setFilters({});
          setSearched(false);
          loadingCharts.set(false);
        }}
        filters={filters}
        setFilters={setFilters}
        searchButton={() => {
          setSearched(true);
        }}
      />
      {!loadingCharts.get() && searched && (
        <ChartsInvolved expandFilterSearch={expandFilterSearch.get()} />
      )}
    </Card>
  );
}